import { motion } from 'framer-motion';
import { Mail, Phone } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { useReservation } from '../context/ReservationContext';
import ImageSlideshow from '../components/ImageSlideshow';

const SLIDESHOW_IMAGES = [
  'https://customer-assets.emergentagent.com/job_vino-vibes/artifacts/a16m95v3_FB_IMG_1770407268708.jpg',
  'https://customer-assets.emergentagent.com/job_6c1e1185-4e2b-4a47-b7ad-68a7aff64ff4/artifacts/56wlshqc_20260414_115456%281%29_resized.jpg',
  'https://customer-assets.emergentagent.com/job_vino-vibes/artifacts/sej0xcfn_FB_IMG_1770407274720.jpg',
  'https://customer-assets.emergentagent.com/job_vino-vibes/artifacts/btdsd6oa_FB_IMG_1770407271743.jpg',
  'https://customer-assets.emergentagent.com/job_6c1e1185-4e2b-4a47-b7ad-68a7aff64ff4/artifacts/feqv4sg4_20260417_212245_resized.jpg',
  'https://customer-assets.emergentagent.com/job_vino-vibes/artifacts/542rn9ub_FB_IMG_1770407386693.jpg',
  'https://customer-assets.emergentagent.com/job_6c1e1185-4e2b-4a47-b7ad-68a7aff64ff4/artifacts/1ejvwmrv_pixelcut-export-1775263013893.jpg',
  'https://customer-assets.emergentagent.com/job_vino-vibes/artifacts/wdt3crgh_FB_IMG_1770407405617.jpg',
  'https://customer-assets.emergentagent.com/job_6c1e1185-4e2b-4a47-b7ad-68a7aff64ff4/artifacts/w0zotuqy_pixelcut-export-1775263307886.jpg',
];

const Private = () => {
  const { t } = useLanguage();
  const reservation = useReservation();

  return (
    <main className="min-h-screen bg-[#0A0A0A] pt-24" data-testid="private-page">
      <section className="py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="font-body text-sm tracking-[0.2em] text-copper mb-4 uppercase"
          >
            {t.privatePage.subtitle}
          </motion.p>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-[#EDEDED] mb-8"
          >
            {t.privatePage.title}
          </motion.h1>
        </div>
      </section>

      <section className="pb-16">
        <div className="max-w-6xl mx-auto px-6 md:px-12">
          <ImageSlideshow images={SLIDESHOW_IMAGES} />
        </div>
      </section>

      <section className="pb-24 md:pb-32">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="space-y-6 font-body text-[#A1A1A1] text-base leading-relaxed"
          >
            <p className="text-[#EDEDED] text-lg">{t.privatePage.intro}</p>
            <p>{t.privatePage.looking}</p>
            <p>{t.privatePage.dream}</p>
            <p>{t.privatePage.exclusive}</p>
            <p>{t.privatePage.interest}</p>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <a
                href="mailto:info@barbaarmiddelkerke.com"
                className="inline-flex items-center justify-center gap-2 px-8 py-3 border border-[#C8A46A] text-[#C8A46A] font-body text-sm tracking-wider uppercase hover:bg-[#C8A46A] hover:text-[#0A0A0A] transition-all duration-300"
                data-testid="private-email-btn"
              >
                <Mail className="w-4 h-4" /> info@barbaarmiddelkerke.com
              </a>
              <a
                href="tel:+32471556751"
                className="inline-flex items-center justify-center gap-2 px-8 py-3 border border-[#C8A46A] text-[#C8A46A] font-body text-sm tracking-wider uppercase hover:bg-[#C8A46A] hover:text-[#0A0A0A] transition-all duration-300"
                data-testid="private-phone-btn"
              >
                <Phone className="w-4 h-4" /> 0471 55 67 51
              </a>
            </div>

            <p className="text-[#EDEDED] italic pt-2">{t.privatePage.hope}</p>
          </motion.div>
        </div>
      </section>
    </main>
  );
};

export default Private;
